module.exports = __webpack_public_path__ + "img/main@2x.5da6674.jpg";